<template>
    <div v-if="open" class="absolute inset-0 z-50 flex flex-col items-center justify-center gap-5 bg-white/95 px-10 text-center">
        <BaseNotification v-if="errorText" theme="error" :text="errorText" hide-dismiss />
        <div class="flex flex-col gap-2">
            <p class="body-semibold text-valence-grey-900">{{ title }}</p>
            <p v-if="body" class="body-small text-valence-grey-600">{{ body }}</p>
        </div>
        <div class="flex gap-2">
            <button
                type="button"
                class="inline-flex items-center gap-1.5 rounded-full border border-valence-grey-300 px-3.5 py-1.5 body-small text-valence-grey-600 hover:bg-slate-50 disabled:opacity-50"
                :disabled="isLoading"
                @click="emit('update:open', false)">
                Cancel
            </button>
            <button
                type="button"
                class="inline-flex items-center gap-1.5 rounded-full bg-valence-primary-500 px-3.5 py-1.5 body-small text-white hover:bg-valence-primary-600 disabled:opacity-50"
                :disabled="isLoading"
                @click="emit('confirmed')">
                <i v-if="isLoading" class="bi bi-arrow-clockwise animate-spin" aria-hidden="true"></i>
                {{ confirmText }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseNotification from "~vue/components/BaseNotification.vue";

withDefaults(
    defineProps<{
        open: boolean;
        title: string;
        body?: string;
        confirmText?: string;
        isLoading?: boolean;
        errorText?: string;
    }>(),
    { confirmText: "Confirm" },
);

const emit = defineEmits<{
    "update:open": [value: boolean];
    confirmed: [];
}>();
</script>
